import React from "react";
import {Link} from "react-router-dom";
import {QinGuanTitle} from "./QinGuan";

function ChillFogLights() {
    return (
        <div className="row">
            <div className="col-md-8 offset-md-2">
                <h1 className="text-center"><Link to="/translation/qinguan/chill-fog-lights">chill fog lights</Link></h1>
                <QinGuanTitle/>
                <div className="text-center">
                    <a href="https://so.gushiwen.cn/shiwenv_8cd9a96daaa4.aspx">Original Text</a>
                </div>
                <hr/>
                <p>
                    chill fog lights on small abode<br/>
                    bleak grey dawn like roguish fall<br/>
                    rolling mist on tranquil screen
                </p>
                <p>
                    catkins drifting light as dreams<br/>
                    boundless rainthreads thin as grief<br/>
                    drapes hang loose from silver hooks
                </p>
                <p>
                    <strong>秦觀，“漠漠輕寒上小樓” <br/> (Qin Guan, "chill fog lights on small abode")</strong>
                </p>
                <p>
                    <em>Trans. Porter James, 2024-01-07</em>
                </p>
            </div>
        </div>
    );
}

export default ChillFogLights
